import { t } from "../../i18n";
import { ALLERGENS, whyText, type Suggestion } from "./allergens";

interface Props {
  certain: ReadonlySet<string>;
  maybe: ReadonlySet<string>;
  /** Tafo's proposal: its reasons show when hovering an allergen. */
  suggestion?: Suggestion | undefined;
}

/**
 * Allergen chips (prototype algChips): certain filled, the reason when hovering. Tafo's list has no
 * doubt since 06/10/2026 ("ik wil geen vraagtekens zien"); a "possible" allergen a shop saved before
 * keeps its dashed line, without the question mark of the prototype.
 */
export function AllergenChips({ certain, maybe, suggestion }: Props) {
  const codes = ALLERGENS.filter((allergen) => certain.has(allergen.code) || maybe.has(allergen.code));
  if (codes.length === 0) return <span className="note">{t.menuAdmin.allergens.none}</span>;
  return (
    <>
      {codes.map((allergen) => {
        const possible = !certain.has(allergen.code);
        return (
          <span
            key={allergen.code}
            className={`alc ${possible ? "m" : "z"}`}
            title={suggestion ? whyText(suggestion, allergen.code) : undefined}
          >
            {allergen.name}
          </span>
        );
      })}
    </>
  );
}
